import React, { useMemo } from 'react';
import { Document } from 'src/types/flow';
import { Col, Row, Text } from 'rsuite';
import { CustomHTML } from '../../../components/common/CustomHTML';
import { ConfigDocument } from 'src/types/configuration';

interface DocumentsProps {
  documents?: Document;
  configDocuments: ConfigDocument[];
}
export const Documents = ({ documents, configDocuments }: DocumentsProps) => {
  const entries = useMemo(
    () => (documents ? Object.entries(documents) : []),
    [documents]
  );

  const hasDocuments = useMemo(
    () => entries.some(([, docValue]) => docValue?.attachedFiles?.length > 0),
    [entries]
  );

  if (!documents || !hasDocuments) {
    return <Text>No documents uploaded</Text>;
  }

  return (
    <Row>
      <Col
        xs={24}
        lg={12}
      >
        <h2>Verification Documents</h2>
        {entries.map(([docKey, docValue], docGroupIdx) => {
          const docInfo = configDocuments?.find((d) => d.file_key === docKey);
          const docs = docValue?.attachedFiles?.map((file, idx) => (
            <Text key={`document_${file.blobFile?.name}_${idx}`}>
              {file.blobFile?.name && file.blobFile?.name !== 'undefined'
                ? file.blobFile?.name
                : file?.name}
            </Text>
          ));
          if (!docs || docs.length === 0) return <></>;
          return (
            <div key={`document_set_${docGroupIdx}`}>
              <Text className="text-bold">
                <CustomHTML text={docInfo?.title ?? ''} />
              </Text>
              {docs}
            </div>
          );
        })}
      </Col>
    </Row>
  );
};
